// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"923366bc","152":"42b79e61","345":"52c44043","504":"1c2e477c","518":"4060d175","594":"f8d17518","894":"8307ed2f"}[chunkId] + ".chunk.js";
};